module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "h-role",
    on: {
      "click": _vm.checkTeacher
    }
  }, [(!_vm.headerData.isQA) ? _c('i', {
    staticClass: "icon iconfont icon-jinhangzhong"
  }) : _vm._e(), _vm._v("\n      " + _vm._s((_vm.headerData.role === 0 || _vm.headerData.role === "教学区") ? "教师端" : "学生端") + "\n    ")]), _vm._v(" "), (_vm.headerData.isQA) ? _c('span', {
    staticClass: "h-role",
    on: {
      "click": _vm.checkStudent
    }
  }, [(_vm.headerData.isQA) ? _c('i', {
    staticClass: "icon iconfont icon-jinhangzhong"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.headerData.nameQA) + "\n      "), _c('i', {
    staticClass: "icon iconfont icon-guanbi",
    on: {
      "click": _vm.closeQA
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.headerData.roomId) ? _c('span', {
    staticClass: "h-id"
  }, [_vm._v("教室ID：" + _vm._s(_vm.headerData.roomId))]) : _vm._e(), _vm._v(" "), (_vm.headerData.number) ? _c('span', {
    staticClass: "h-num"
  }, [_vm._v("在线人数：" + _vm._s(_vm.headerData.number))]) : _vm._e()]), _vm._v(" "), _c('div', {}), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178e6932","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/index.vue
// module id = 504
// module chunks = 1